// @flow
import type { LeafRuleProps } from 'types/rule-types';

import React, { Component } from 'react';
import { Form } from 'semantic-grab-ui/src';
import _ from 'lodash';
import i18n from 'i18n-js';

const MIN_DAY = 0;
const MAX_DAY = 180;
const DEFAULT_DAY = 30;

function getSelectOptions() {
  return [
    {
      key: 1,
      text: i18n.t('rule_builder.new_to_gp.lifetime'),
      value: 1,
    },
    {
      key: 2,
      text: i18n.t('rule_builder.new_to_gp.custom'),
      value: 2,
    },
  ];
}
export default class NewToGPMexStoreRule extends Component {
  props: any;
  constructor(props: LeafRuleProps) {
    super(props);
    let selectValue = 1;
    let inputValue = DEFAULT_DAY;
    const rhs = _.get(props, 'rule.rhs');
    if (rhs && rhs.churnedDay) {
      const churnedDay = rhs.churnedDay;
      if (churnedDay > -1) {
        selectValue = 2;
        inputValue = churnedDay;
      }
    }
    this.state = {
      selectValue,
      inputValue,
    };
  }

  componentDidMount() {
    if (_.isEmpty(_.get(this.props, 'rule.rhs'))) {
      const { rule } = this.props;
      this.props.onRuleChange({ ...rule, rhs: { churnedDay: -1 } });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Object) {
    this.setState({ rhs: _.get(nextProps, 'rule.rhs') });
  }

  handleInputChange = (event: any, data: any) => {
    const { rule } = this.props;
    let value = parseInt(_.get(event, 'target.value') || _.get(data, 'value'), 10) || MIN_DAY;
    if (value < MIN_DAY) {
      value = MIN_DAY;
    }
    if (value > MAX_DAY) {
      value = MAX_DAY;
    }
    this.setState({ inputValue: value });
    this.props.onRuleChange({ ...rule, rhs: { churnedDay: value } });
  }

  handleSelectChange = (event: any, data: any) => {
    const { rule } = this.props;
    const value = parseInt(_.get(event, 'target.value') || _.get(data, 'value'), 10);
    let churnedDay = -1;
    if (value === 2) {
      churnedDay = this.state.inputValue;
    }
    this.setState({ selectValue: value });
    this.props.onRuleChange({ ...rule, rhs: { churnedDay } });
  }

  render() {
    const { isSelected, ruleType } = this.props;
    return (
      <span>
        <span>{`${ruleType.noun}  `}</span>
        <Form.Field>
          <Form.Select
            required
            label={i18n.t('rule_builder.new_to_gp.select_label')}
            options={getSelectOptions()}
            value={this.state.selectValue}
            onChange={this.handleSelectChange}
            disabled={!isSelected}
          />
          { this.state.selectValue === 2 ?
            <Form.Input
              type="number"
              label={` ${i18n.t('rule_builder.new_to_gp.input_label')} `}
              value={this.state.inputValue}
              onChange={this.handleInputChange}
              disabled={!isSelected}
            /> : null }
        </Form.Field>
      </span>
    );
  }
}
